import dayjs from "dayjs";

export const isValidDateOfBirth = (value: string): string | boolean =>
  (dayjs().diff(value, "year") < 130 && dayjs().isAfter(value)) ||
  "Not a valid date of birth";
